import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import userManager from './userManager';

/**
 * A component that finalizes the OIDC login flow.
 * It is used as the redirect URL after authentication.
 */
const Callback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        async function finishLogin() {
            try {
                await userManager.signinRedirectCallback();
                window.history.replaceState({}, document.title, window.location.origin);
                navigate('/');
            } catch (err) {
                console.error('Callback error:', err);
                navigate('/');
            }
        }
        finishLogin();
    }, [navigate]);

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 2 }}>
                Signing in...
            </Typography>
        </div>
    );
};

export default Callback;
